<bd-modal #htmlInsideModal [closable]="true" title="Zugänge einrichten"
          class="improved-modal slide-modal it-scope-modal">
    <div class="modal-body login-box-it-scope">
        <div class="tabs {{isSecondTabActive ? 'second-active' : ''}}">

            <!--tab-->
            <div class="tab">
                <img src="./assets/img/logo_itscope.png" alt="logo itscope" class="logo-itscope">
                <h3 class="bigger font-bolder">IT Scope</h3>
                <p>Um alle in der App verfügbaren Informationen sehen zu können, müssen Sie noch wenige weitere
                    Anmeldedaten hinterlegen.</p>

                <div class="mb-2 d-block">
                    <a href="javascript:;" (click)=dataProtectionModal.open()>
                        <bd-fa name="info-circle"></bd-fa>
                        Datenschutz
                    </a>
                </div>


                <div class="input-group" [class.has-success]="hasSuccess(loginITScope)"
                     [class.has-error]="hasError(loginITScope) || hasWsError">
                    <label type="text">E-Mail Adresse</label>
                    <input name="loginITScope" required #loginITScope="ngModel" autocomplete="none"
                           [(ngModel)]="model.itscope.login" placeholder="ITScope E-Mail Adresse eingeben"
                           [disabled]="hasITScopeCredential()"
                           [pattern]="EMAIL_PATTERN">
                </div>

                <div class="input-group with-btn" [class.has-success]="hasSuccess(securityITScope)"
                     [class.has-error]="hasError(securityITScope) || hasWsError">
                    <label>Passwort</label>
                    <input name="passwordITSCope" type="password" autocomplete="new-password" required
                           #securityITScope="ngModel" [(ngModel)]="model.itscope.security"
                           placeholder="Passwort eingeben" [disabled]="hasITScopeCredential()">
                    <button type="button" class="toggle-pw-visibility "
                            (click)="togglePasswordVisibility($event)" [disabled]="hasITScopeCredential()">

                    </button>
                </div>


                <div class="d-flex mt-1 info-container">
                    <div class="error-container" *ngIf="hasWsError">
                        Fehler: Bitte überprüfen Sie Ihre ITScope Zugangsdaten.
                    </div>
                </div>

                <button type="submit" class="btn btn-primary small font-bold fw mb-1" (click)="saveITScope()"
                        [disabled]="!(hasSuccess(loginITScope) && hasSuccess(securityITScope))">
                    Weiter
                </button>

                <button type="submit" class="btn btn-light small font-bold fw" (click)="skipITScope()">
                    Überspringen
                </button>
            </div>

            <!--2nd tab-->
            <!--
            <div class="tab">
                <img src="./assets/img/logo_interaktiv.png" alt="logo interaktiv" class="logo-interaktiv">
                <h3 class="bigger font-bolder">interaktiv Punkteprogramm</h3>
                <p>Um alle in der App verfügbaren Informationen sehen zu können, müssen Sie noch wenige weitere Anmeldedaten hinterlegen.</p>

                <a href="#" class="mb-1 d-block">
                    <bd-fa name="info-circle"></bd-fa>
                    Datenschutz</a>


                <div class="input-group" [class.has-success]="hasSuccess(loginCadooz)" [class.has-error]="hasError(loginCadooz)">
                    <label type="text">E-Mail Adresse</label>
                    <input name="login" required email #loginCadooz="ngModel" [(ngModel)]="model.cadooz.login" placeholder="E-Mail Adresse eingeben" [disabled]="hasCadoozCredential()">
                </div>

                <div class="input-group with-btn" [class.has-success]="hasSuccess(securityCadooz)" [class.has-error]="hasError(securityCadooz)">
                    <label>Passwort</label>
                    <input name="password" type="password" required #securityCadooz="ngModel" [(ngModel)]="model.cadooz.security" placeholder="Passwort eingeben" [disabled]="hasCadoozCredential()">
                    <button type="button" class="toggle-pw-visibility "
                            (click)="togglePasswordVisibility($event)" [disabled]="hasCadoozCredential()"></button>
                </div>

                <div class="d-flex mb-2 mt-1">
                    <a *ngIf="!hasCadoozCredential()" href="#" class="small ml-auto underline">Passwort vergessen?</a>
                </div>

                <button type="submit" class="btn btn-primary small fw mb-1 font-bold" (click)="saveCadooz()" [disabled]="!(hasSuccess(loginCadooz) && hasSuccess(securityCadooz))">
                    Weiter
                </button>

                <button type="submit" class="btn btn-light small font-bold fw" (click)="skipCadooz()">
                    Überspringen
                </button>
            </div>
            -->
        </div>
        <!--
        <div class="switchers">
            <div (click)="isSecondTabActive = false" [ngClass]="{'active' : !isSecondTabActive}"></div>
            <div (click)="isSecondTabActive = true" [ngClass]="{'active' : isSecondTabActive}"></div>
        </div>
        -->
    </div>
</bd-modal>

<bd-modal #dataProtectionModal [closable]="true" class="improved-modal no-header modal-on-modal">
    <div class="modal-body">
        <h3 class="mt-0 mb-0 font-bolder">Datenschutz</h3>
        <h4 class="font-bolder">Nutzung Ihrer Daten</h4>
        <p class="mt-0 mb-0 small">
            Ihre IT-Scope-Zugangsdaten werden ausschließlich dazu
            genutzt, Ihnen zusätzliche Informationen in der App
            darzustellen. Dies umfasst Preisdaten sowie
            Bestandsdaten bei zertifizierten Distributoren.
        </p>
        <p class="mb-0 small">
            Damit werden Ihre Recherchen in der App noch einfacher
            und effektiver.
        </p>
        <h4 class="font-bolder">Ihre Daten sind sicher</h4>
        <p class="mt-0 mb-0 small">
            Die Sicherheit Ihrer IT-Scope-Zugänge hat für uns oberste
            Priorität. Es können daher in der App keine Bestellungen
            oder sonstige geschäftsrelevante Aktionen über Ihren
            IT-Scope-Zugang ausgeführt werden.
        </p>
        <p class="mb-0 small">
            Ihre Daten werden zudem sicher abgespeichert und von
            Brother-Mitarbeitern nicht eingesehen. Natürlich können
            Sie Ihre Daten nachträglich jederzeit löschen.
        </p>
        <p class="mb-0 small">
            Für weitere Informationen lesen Sie unsere
            <a href="https://www.brother.de/unternehmen/datenschutzrichtlinie" target="_blank">Datenschutzhinweise</a>
            oder sprechen Sie uns an.
        </p>
    </div>
</bd-modal>
